import React from 'react';

const RefineResultModalHeader = ({ title }) => {
    return (
        <div className='modal__header'>
            <span className='modal__close' data-dismiss='modal' title='Close'>
                <i className='icon icon-close' />
            </span>
            <h4 className='heading heading--lv4'>{title}</h4>
        </div>
    );
};

export default RefineResultModalHeader;
